import { Card, Col, Image, Row } from 'react-bootstrap';
import { imgUrl } from '../../../../Helpers/Constant';
import { FaCalendarAlt, FaClock } from 'react-icons/fa';
import moment from 'moment';
import { amPmTimeShowForSlot } from '../utility/b2bUtility';
import { IMyRequestedSlotList } from '../../type/b2bBuyerSellerType';
import MeetingApprovedReject from '../Slot/MeetingApprovedReject';

const MyMeetingRequestComm = ({
  data,
  self,
  showApprove,
  showCancelled,
  showRejected,
}: {
  data: IMyRequestedSlotList[] | undefined;
  self: 'to' | 'from';
  showApprove?: boolean;
  showRejected?: boolean;
  showCancelled?: boolean;
}) => {
  return (
    <Row className='g-4'>
      {data?.map((request) => (
        <Col key={request.id} md={6} lg={4} xl={4} xxl={4}>
          <Card className='request-card h-100'>
            <Card.Body>
              <div className='d-flex align-items-center mb-3'>
                <Image
                  src={`${imgUrl}/${
                    self === 'from'
                      ? request.requested_from_company_logo
                      : request.requested_to_company_logo
                  }`}
                  roundedCircle
                  width={50}
                  height={50}
                  className='me-3'
                  alt={
                    self === 'from'
                      ? request.requested_from_company_logo
                      : request.requested_to_company_logo
                  }
                />
                <div>
                  <h5 className='mb-0'>
                    {self === 'from'
                      ? request.requested_from_company_name
                      : request.requested_to_company_name}
                  </h5>
                  <small className='text-muted'>
                    {self === 'from'
                      ? request.requested_from_type
                      : request.requested_to_type}
                  </small>
                </div>
              </div>

              <div className='d-flex align-items-center mb-2'>
                <FaCalendarAlt className='me-2 text-primary' />
                <span>
                  Requested on:{' '}
                  {moment(request.created_at).format('dddd, DD MMM YYYY')}
                </span>
              </div>

              <div className='d-flex align-items-center mb-3'>
                <FaClock className='me-2 text-primary' />
                <span>
                  {moment(request?.start_time).format('DD-MMM-YYYY')} <br />
                  Slot :{' '}
                  {amPmTimeShowForSlot(
                    request.start_time,
                    request.end_time
                  )}{' '}
                </span>
              </div>

              {request?.rejected_reason && (
                <span>
                  {' '}
                  <span className='text-danger'>Reject Reason</span> :{' '}
                  {request?.rejected_reason}
                </span>
              )}

              <MeetingApprovedReject
                showApprove={showApprove}
                showCancelled={showCancelled}
                showRejected={showRejected}
                id={request.id}
              />
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default MyMeetingRequestComm;
